import {apolloClient} from '@/setup/apollo-setup'

import {
  GET_CONTRACT_DETAIL,
  GET_CONTRACT_DETAIL_TRANSFER_SCHEDULES,
  CALCULATE_CONTRACT_DETAIL,
  // borrower

  // surety details
  CREATE_CONTRACT_DETAIL_SURETY_DETAIL,
  DELETE_CONTRACT_DETAIL_SURETY_DETAIL,
  // files
  CREATE_CONTRACT_DETAIL_FILE,
  DELETE_CONTRACT_DETAIL_FILE,
  // call histories
  CREATE_CONTRACT_DETAIL_CALL_HISTORY,
  DELETE_CONTRACT_DETAIL_CALL_HISTORY,
  RECEIVE_CONTRACT_DETAIL_CALL_HISTORY,
  UN_RECEIVE_CONTRACT_DETAIL_CALL_HISTORY,
  // send sms histories
  CREATE_CONTRACT_DETAIL_SEND_SMS_HISTORY,
  DELETE_CONTRACT_DETAIL_SEND_SMS_HISTORY,
  // send doc histories
  CREATE_CONTRACT_DETAIL_SEND_DOC_HISTORY,
  DELETE_CONTRACT_DETAIL_SEND_DOC_HISTORY,
  // notification
  CREATE_CONTRACT_DETAIL_NOTIFICATION,
  UPDATE_CONTRACT_DETAIL_NOTIFICATION,
  APPROVED_CONTRACT_DETAIL_NOTIFICATION,
  DELETE_CONTRACT_DETAIL_NOTIFICATION,
  CANCEL_CONTRACT_DETAIL_NOTIFICATION,
  // fee details
  CREATE_CONTRACT_DETAIL_FEE_DETAIL,
  UPDATE_CONTRACT_DETAIL_FEE_DETAIL,
  DELETE_CONTRACT_DETAIL_FEE_DETAIL,
  CALCULATE_CONTRACT_DETAIL_FEE_DETAIL,
  // expense details
  CREATE_CONTRACT_DETAIL_EXPENSE_DETAIL,
  UPDATE_CONTRACT_DETAIL_EXPENSE_DETAIL,
  APPROVED_CONTRACT_DETAIL_EXPENSE_DETAIL,
  CANCELED_CONTRACT_DETAIL_EXPENSE_DETAIL,
  DELETE_CONTRACT_DETAIL_EXPENSE_DETAIL,
  // payments
  CREATE_CONTRACT_DETAIL_PAYMENT,
  UPDATE_CONTRACT_DETAIL_PAYMENT,
  DELETE_CONTRACT_DETAIL_PAYMENT,
  CALCULATE_CONTRACT_DETAIL_PAYMENT,
  // payment expenses
  CREATE_CONTRACT_DETAIL_PAYMENT_EXPENSE,
  UPDATE_CONTRACT_DETAIL_PAYMENT_EXPENSE,
  APPROVED_CONTRACT_DETAIL_PAYMENT_EXPENSE,
  CANCELED_CONTRACT_DETAIL_PAYMENT_EXPENSE,
  DELETE_CONTRACT_DETAIL_PAYMENT_EXPENSE,
  // transfer schedules
  CREATE_CONTRACT_DETAIL_TRANSFER_SCHEDULE,
  DELETE_CONTRACT_DETAIL_TRANSFER_SCHEDULE,
  // payment rounds
  CREATE_CONTRACT_DETAIL_PAYMENT_ROUNDS,
  DELETE_CONTRACT_DETAIL_PAYMENT_ROUNDS,
  // transactions
  DELETE_TRANSACTIONS_BY_CONTRACT_ID_AND_TRANSACTION_DATE,
} from '@/queries/modules/accounting/index.js'

import {
  addItemSuccess,
  calculateContractDetailPaymentSuccess,
  calculateContractDetailSuccess,
  deleteItemSuccess,
  error,
  receiveSuccess,
  unReceiveSuccess,
  updateItemSuccess,
} from '@/utils/notification'

export async function getContractDetail(context, payload) {
  // console.log('Get Contract Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_DETAIL,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContractDetail: contractDetail} = await data
    context.commit('setContractDetail', contractDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function clearTransactionsContractDetail(context, payload) {
  // console.log('Clear Transactions Contract Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      contractId: payload.contractId,
      transactionDate: payload.date,
      extra: false,
    }
    // console.log(variables)
    await apolloClient
      .mutate({
        mutation: DELETE_TRANSACTIONS_BY_CONTRACT_ID_AND_TRANSACTION_DATE,
        variables,
        fetchPolicy: 'no-cache'
      })

    await getContractDetail(context, {id: payload.contractId})
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function calculateContractDetail(context, payload) {
  // console.log('Calculate Contract Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    updateToNow: payload.updateToNow,
    updateToDate: payload.updateToDate,
    index: 0,
  }
  // console.log('calculateContractDetail', variables)
  try {
    await apolloClient
      .mutate({
        mutation: CALCULATE_CONTRACT_DETAIL,
        variables,
      })
    await getContractDetail(context, {id: payload.contractId})

    context.commit('setSuccess', calculateContractDetailSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }

}

// borrower

// surety details
export async function createContractDetailSuretyDetail(context, payload) {
  // console.log('Create Contract Detail Surety Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  // console.log('variables', variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_SURETY_DETAIL,
        variables,
      })
    const {data} = await response
    const { createContractDetailSuretyDetail:  contractDetailSuretyDetail} = data
    context.commit('addContractDetailSuretyDetail', contractDetailSuretyDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailSuretyDetail(context, payload) {
  // console.log('Delete Contract Detail Surety Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_SURETY_DETAIL,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailSuretyDetail: { id } } = data
    context.commit('delContractDetailSuretyDetail', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// files
export async function createContractDetailFile(context, payload) {
  // console.log('Create Contract Detail File...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_FILE,
        variables,
      })
    const {data} = await response
    const { createContractDetailFile: contractDetailFile} = data
    context.commit('addContractDetailFile', contractDetailFile)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailFile(context, payload) {
  // console.log('Delete Contract Detail File...')
  // console.log('payload: ', payload)

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_FILE,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailFile: { id } } = data
    context.commit('delContractDetailFile', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// call histories
export async function createContractDetailCallHistory(context, payload) {
  // console.log('Create Contract Detail NotificationCall History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_CALL_HISTORY,
        variables,
      })
    const {data} = await response
    const { createContractDetailCallHistory: contractDetailCallHistory} = data
    context.commit('addContractDetailCallHistory', contractDetailCallHistory)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailCallHistory(context, payload) {
  // console.log('Delete Contract Detail NotificationCall History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_CALL_HISTORY,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailCallHistory: { id } } = data
    context.commit('delContractDetailCallHistory', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function receiveContractDetailCallHistory(context, payload) {
  // console.log('Receive Contract Detail NotificationCall History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { contractId: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: RECEIVE_CONTRACT_DETAIL_CALL_HISTORY,
        variables,
      })
    const {data} = await response
    const { receiveContractDetailCallHistory:  contractDetail } = data
    context.commit('updateContractDetailReceivedStatus', contractDetail)
    context.commit('setSuccess', receiveSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function unReceiveContractDetailCallHistory(context, payload) {
  // console.log('Un-Receive Contract Detail NotificationCall History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { contractId: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UN_RECEIVE_CONTRACT_DETAIL_CALL_HISTORY,
        variables,
      })
    const {data} = await response
    const { unReceiveContractDetailCallHistory:  contractDetail } = data
    context.commit('updateContractDetailReceivedStatus', contractDetail)
    context.commit('setSuccess', unReceiveSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// send sms histories
export async function createContractDetailSendSmsHistory(context, payload) {
  // console.log('Create Contract Detail Send Sms History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_SEND_SMS_HISTORY,
        variables,
      })
    const {data} = await response
    const { createContractDetailSendSmsHistory: contractDetailSendSmsHistory} = data
    context.commit('addContractDetailSendSmsHistory', contractDetailSendSmsHistory)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailSendSmsHistory(context, payload) {
  // console.log('Delete Contract Detail Send Sms History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_SEND_SMS_HISTORY,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailSendSmsHistory: { id } } = data
    context.commit('delContractDetailSendSmsHistory', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// send doc histories
export async function createContractDetailSendDocHistory(context, payload) {
  // console.log('Create Contract Detail Send Doc History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_SEND_DOC_HISTORY,
        variables,
      })
    const {data} = await response
    const { createContractDetailSendDocHistory: contractDetailSendDocHistory} = data
    context.commit('addContractDetailSendDocHistory', contractDetailSendDocHistory)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailSendDocHistory(context, payload) {
  // console.log('Delete Contract Detail Send Doc History...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_SEND_DOC_HISTORY,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailSendDocHistory: { id } } = data
    context.commit('delContractDetailSendDocHistory', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// notification
export async function createContractDetailNotification(context, payload) {
  // console.log('Create Contract Detail Notification...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_NOTIFICATION,
        variables,
      })
    const {data} = await response
    const { createContractDetailNotification: contractDetailNotification} = data
    context.commit('addContractDetailNotification', contractDetailNotification)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContractDetailNotification(context, payload) {
  // console.log('Update Contract Detail Notification...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT_DETAIL_NOTIFICATION,
        variables,
      })
    const {data} = await response
    const { updateContractDetailNotification: contractDetailNotification} = data

    context.commit('updateContractDetailNotification', contractDetailNotification)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function approvedContractDetailNotification(context, payload) {
  // console.log('Approve Contract Detail Notification...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: APPROVED_CONTRACT_DETAIL_NOTIFICATION,
        variables,
      })
    const {data} = await response
    const { approvedContractDetailNotification: contractDetailNotification} = data

    context.commit('updateContractDetailNotification', contractDetailNotification)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailNotification(context, payload) {
  // console.log('Delete Contract Detail Notification...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_NOTIFICATION,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailNotification: { id } } = data
    context.commit('delContractDetailNotification', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function cancelContractDetailNotification(context, payload) {
  // console.log('Cancel Contract Detail Notification...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CANCEL_CONTRACT_DETAIL_NOTIFICATION,
        variables,
      })
    const {data} = await response
    const { cancelContractDetailNotification: contractDetailNotification} = data

    context.commit('updateContractDetailNotification', contractDetailNotification)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// fee details
export async function createContractDetailFeeDetail(context, payload) {
  // console.log('Create Contract Detail Fee Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_FEE_DETAIL,
        variables,
      })
    const {data} = await response
    const { createContractDetailFeeDetail: contractDetailFeeDetail} = data
    context.commit('addContractDetailFeeDetail', contractDetailFeeDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContractDetailFeeDetail(context, payload) {
  // console.log('Update Contract Detail Fee Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT_DETAIL_FEE_DETAIL,
        variables,
      })
    const {data} = await response
    const { updateContractDetailFeeDetail: contractDetailFeeDetail} = data

    context.commit('updateContractDetailFeeDetail', contractDetailFeeDetail)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailFeeDetail(context, payload) {
  // console.log('Delete Contract Detail Fee Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_FEE_DETAIL,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailFeeDetail: { id } } = data
    context.commit('delContractDetailFeeDetail', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function calculateContractDetailFeeDetail(context, payload) {
  // console.log('Calculate Contract Detail Fee Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    updateToNow: true,
    updateToDate: null,
    index: 0,
  }
  try {
    await apolloClient
      .mutate({
        mutation: CALCULATE_CONTRACT_DETAIL_FEE_DETAIL,
        variables,
      })
    await getContractDetail(context, {id: payload.contractId})

    context.commit('setSuccess', calculateContractDetailPaymentSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// expense details
export async function createContractDetailExpenseDetail(context, payload) {
  // console.log('Create Contract Detail Expense Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_EXPENSE_DETAIL,
        variables,
      })
    const {data} = await response
    const { createContractDetailExpenseDetail: contractDetailExpenseDetail} = data
    context.commit('addContractDetailExpenseDetail', contractDetailExpenseDetail)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContractDetailExpenseDetail(context, payload) {
  // console.log('Update Contract Detail Expense Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT_DETAIL_EXPENSE_DETAIL,
        variables,
      })
    const {data} = await response
    const { updateContractDetailExpenseDetail: contractDetailExpenseDetail} = data

    context.commit('updateContractDetailExpenseDetail', contractDetailExpenseDetail)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function approvedContractDetailExpenseDetail(context, payload) {
  // console.log('Approved Contract Detail Expense Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: APPROVED_CONTRACT_DETAIL_EXPENSE_DETAIL,
        variables,
      })
    const {data} = await response
    const { approvedContractDetailExpenseDetail: contractDetailExpenseDetail} = data

    context.commit('updateContractDetailExpenseDetail', contractDetailExpenseDetail)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function canceledContractDetailExpenseDetail(context, payload) {
  // console.log('Canceled Contract Detail Expense Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CANCELED_CONTRACT_DETAIL_EXPENSE_DETAIL,
        variables,
      })
    const {data} = await response
    const { canceledContractDetailExpenseDetail: contractDetailExpenseDetail} = data

    context.commit('updateContractDetailExpenseDetail', contractDetailExpenseDetail)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailExpenseDetail(context, payload) {
  // console.log('Delete Contract Detail Expense Detail...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_EXPENSE_DETAIL,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailExpenseDetail: { id } } = data
    context.commit('delContractDetailExpenseDetail', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// payments
export async function createContractDetailPayment(context, payload) {
  // console.log('Create Contract Detail Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_PAYMENT,
        variables,
      })
    const {data} = await response
    const { createContractDetailPayment: contractDetailPayment} = data
    context.commit('addContractDetailPayment', contractDetailPayment)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContractDetailPayment(context, payload) {
  // console.log('Update Contract Detail Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT_DETAIL_PAYMENT,
        variables,
      })
    const {data} = await response
    const { updateContractDetailPayment: contractDetailPayment} = data

    context.commit('updateContractDetailPayment', contractDetailPayment)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailPayment(context, payload) {
  // console.log('Delete Contract Detail Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_PAYMENT,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailPayment: { id } } = data
    context.commit('delContractDetailPayment', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function calculateContractDetailPayment(context, payload) {
  // console.log('Calculate Contract Detail Payment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  // contractId: $contractId,
  //   updateToNow: $updateToNow,
  //   updateToDate: $updateToDate,
  //   index: $index

  const variables = {
    contractId: payload.contractId,
    updateToNow: true,
    updateToDate: null,
    index: 0,
  }
  try {
    await apolloClient
      .mutate({
        mutation: CALCULATE_CONTRACT_DETAIL_PAYMENT,
        variables,
      })
    await getContractDetail(context, {id: payload.contractId})

    context.commit('setSuccess', calculateContractDetailPaymentSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }

}

// payment expenses
export async function createContractDetailPaymentExpense(context, payload) {
  // console.log('Create Contract Detail Payment Expense...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_PAYMENT_EXPENSE,
        variables,
      })
    const {data} = await response
    const { createContractDetailPaymentExpense: contractDetailPaymentExpense} = data
    context.commit('addContractDetailPaymentExpense', contractDetailPaymentExpense)
    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function updateContractDetailPaymentExpense(context, payload) {
  // console.log('Update Contract Detail Payment Expense...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONTRACT_DETAIL_PAYMENT_EXPENSE,
        variables,
      })
    const {data} = await response
    const { updateContractDetailPaymentExpense: contractDetailPaymentExpense} = data

    context.commit('updateContractDetailPaymentExpense', contractDetailPaymentExpense)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function approvedContractDetailPaymentExpense(context, payload) {
  // console.log('Approved Contract Detail Payment Expense...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: APPROVED_CONTRACT_DETAIL_PAYMENT_EXPENSE,
        variables,
      })
    const {data} = await response
    const { approvedContractDetailPaymentExpense: contractDetailPaymentExpense} = data

    context.commit('updateContractDetailPaymentExpense', contractDetailPaymentExpense)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function canceledContractDetailPaymentExpense(context, payload) {
  // console.log('Canceled Contract Detail Payment Expense...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CANCELED_CONTRACT_DETAIL_PAYMENT_EXPENSE,
        variables,
      })
    const {data} = await response
    const { canceledContractDetailPaymentExpense: contractDetailPaymentExpense} = data

    context.commit('updateContractDetailPaymentExpense', contractDetailPaymentExpense)
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailPaymentExpense(context, payload) {
  // console.log('Delete Contract Detail Payment Expense...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_PAYMENT_EXPENSE,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailPaymentExpense: { id } } = data
    context.commit('delContractDetailPaymentExpense', id)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}


// transfer schedules
export async function createContractDetailTransferSchedule(context, payload) {
  // console.log('Create Contract Detail Transfer Schedule...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_TRANSFER_SCHEDULE,
        variables,
      })
    const {data} = await response
    const { createContractDetailTransferSchedule: contractDetailTransferSchedule} = data
    context.commit('addContractDetailTransferSchedule', contractDetailTransferSchedule)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailTransferSchedule(context, payload) {
  // console.log('Delete Contract Detail Transfer Schedule...')

  context.commit('clearError')
  context.commit('setProcessing', true)


  try {
    const variables = {
      type: payload.type,
      id: payload.id
    }
   await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_TRANSFER_SCHEDULE,
        variables,
      })

    const variables2 = { id: payload.contractId }
    const response = await apolloClient
      .query({
        query: GET_CONTRACT_DETAIL_TRANSFER_SCHEDULES,
        variables: variables2,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getContractDetail: { transferSchedules }} = await data
    context.commit('setContractDetailTransferSchedules', transferSchedules)

    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

// payment rounds
export async function createContractDetailPaymentRounds(context, payload) {
  // console.log('Create Contract Detail Payment Round...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractId: payload.contractId,
    input: payload.form,
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CONTRACT_DETAIL_PAYMENT_ROUNDS,
        variables,
      })
    const {data} = await response
    const { createContractDetailPaymentRounds: contractDetailPaymentRounds} = data

    // console.log('contractDetailPaymentRounds', contractDetailPaymentRounds)

    context.commit('addContractDetailPaymentRounds', contractDetailPaymentRounds)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteContractDetailPaymentRounds(context, payload) {
  // console.log('Delete Contract Detail Payment Round...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = { id: payload.id }
  try {
    const response = await apolloClient
      .mutate({
        mutation: DELETE_CONTRACT_DETAIL_PAYMENT_ROUNDS,
        variables,
      })
    const {data} = await response
    const { deleteContractDetailPaymentRounds: { count } } = data
    context.commit('delContractDetailPaymentRounds', count)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}
